import {
  CError,
} from '../consoleMixin'
import {
  getAxiosClient,
} from './axios-client'

class ReserveAccount {
  constructor (clientId) {
    this.clientId = clientId
    this.baseURL = `clients`
  }

  // eslint-disable-next-line no-unused-vars
  async list (paginationParams) {
    try {
      return await (await getAxiosClient(this.baseURL)).get(`${this.clientId}/reserve-account-funds`, {
        params: {
          client_id: this.clientId,
          limit: paginationParams.limit,
          page: paginationParams.page,
          sort_by: "created_at",
          sort_direction: "DESC",
        },
      })
    }
    catch (error) {
      CError(`Could not list reserve account from V2 API`, error)
      throw error
    }
  }

  async postReserveAccount (payload) {
    return (await getAxiosClient(this.baseURL)).post(`${this.clientId}/reserve-account-funds`, {
      ...payload,
    })
  }
}

export default ReserveAccount
